import React from "react";
import { CONTACT } from "../data";
import { Download, MessageCircle } from "lucide-react";

const Nav = ({ onDownloadPdf }) => {
  return (
    <header
      className="no-print fixed top-0 left-0 right-0 z-50 glass"
      style={{ background: "rgba(4,11,22,0.6)" }}
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo">
          <div className="w-9 h-9 flex items-center justify-center" style={{ background: "var(--ocean-accent)", color: "#04111E" }}>
            <span className="font-display font-semibold text-lg">A</span>
          </div>
          <div className="leading-tight">
            <div className="font-display text-lg">Apecatu</div>
            <div className="overline text-[0.55rem]" style={{ color: "var(--ocean-muted)" }}>
              Abrolhos · 2026/27
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8 text-sm" style={{ color: "var(--ocean-muted)" }}>
          <a href="#experiencia" className="hover:text-white" data-testid="nav-experiencia">Experiência</a>
          <a href="#barco" className="hover:text-white" data-testid="nav-barco">Catamarã ZEUS</a>
          <a href="#pacotes" className="hover:text-white" data-testid="nav-pacotes">Pacotes</a>
          <a href="#agenda" className="hover:text-white" data-testid="nav-agenda">Agenda</a>
          <a href="#reserva" className="hover:text-white" data-testid="nav-reserva">Reservar</a>
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={onDownloadPdf}
            className="btn-ghost hidden sm:inline-flex"
            data-testid="nav-download-pdf"
          >
            <Download size={14} /> PDF
          </button>
          <a
            href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent("Olá! Tenho interesse nas expedições Abrolhos 2026/2027.")}`}
            target="_blank"
            rel="noreferrer"
            className="btn-primary"
            data-testid="nav-whatsapp"
          >
            <MessageCircle size={14} /> WhatsApp
          </a>
        </div>
      </div>
    </header>
  );
};

export default Nav;